import * as types from '../constants/actionTypes';

export const fetchPackagesAction = (payload) => ({
  type: types.FETCH_PACKAGES_REQUEST,
  payload
});



// WEBPACK FOOTER //
// ./src/actions/packages.js